import {ThemeOptions} from '@mui/material/styles';
import {createBreakpoints} from "@mui/system";
import {CUSTOM_BREAKPOINTS} from "./PortalTheme";

const breakpoints = createBreakpoints({...CUSTOM_BREAKPOINTS})

const testamentTheme: ThemeOptions = {
    breakpoints,
    palette: {
        mode: 'light',
        primary: {
            main: '#1c3959',
            light: '#0076B9',
            contrastText: "#FFFFFF",
        },
    },
    spacing: 4,
    typography: {
        fontFamily: '"Helvetica Neue LT W01_41488878", Helvetica, Arial, sans-serif;',
        fontSize: 14,
        h1: {
            fontSize: '3.25rem',
            fontWeight: '700',
            fontFamily: 'var(--font-family-bold)',
            letterSpacing: '-0.09375rem',
            lineHeight: '120%',
            [breakpoints.down('md')]: {
                fontSize: '2.75rem',
                letterSpacing: '-0.0625rem',
            },
            [breakpoints.down('sm')]: {
                fontSize: '2.25rem',
                letterSpacing: '-0.0625rem',
            },
        },
        h2: {
            fontSize: '2.75rem',
            fontWeight: '700',
            fontFamily: 'var(--font-family-bold)',
            letterSpacing: '-0.03125rem',
            lineHeight: '120%',
            [breakpoints.only('md')]: {
                fontSize: '2.25rem',
            },
            [breakpoints.down('sm')]: {
                fontSize: '1.75rem',
            },
        },
        h3: {
            fontSize: '2rem',
            fontWeight: '700',
            fontFamily: 'var(--font-family-bold)',
            letterSpacing: '0px',
            lineHeight: '120%',
            [breakpoints.only('md')]: {
                fontSize: '1.75m',
            },
            [breakpoints.down('sm')]: {
                fontSize: '1.5rem',
            },
        },
        h4: {
            fontSize: '1.25rem',
            fontWeight: '700',
            fontFamily: 'var(--font-family-bold)',
            letterSpacing: '0.01563rem',
            lineHeight: '125%',
            [breakpoints.down('md')]: {
                fontSize: '1.25rem',
            },
        },
        h5: {
            fontSize: '1.25rem',
            fontWeight: '700',
            fontFamily: 'var(--font-family-bold)',
            letterSpacing: '0.01563rem',
            lineHeight: '125%',
            [breakpoints.down('md')]: {
                fontSize: '1.188rem',
            },
        },
        h6: {
            fontSize: '1.25rem',
            fontWeight: '700',
            fontFamily: 'var(--font-family-bold)',
            letterSpacing: '0.01563rem',
            lineHeight: '160%',
            [breakpoints.down('md')]: {
                fontSize: '1.25rem',
            },
        },
        subtitle1: {
            fontSize: '1rem',
            fontWeight: '400',
            letterSpacing: '0.00938rem',
            lineHeight: '175%'
        },
        subtitle2: {
            fontSize: '0.875rem',
            fontWeight: '400',
            letterSpacing: '0.1px',
            lineHeight: '157%'
        },
        body1: {
            fontSize: '1.125rem',
            fontWeight: '400',
            letterSpacing: '0.15px',
            lineHeight: '150%'
        },
        body2: {
            fontSize: '1rem',
            fontWeight: '400',
            letterSpacing: '0.17px',
            lineHeight: '143%'
        },
        caption: {
            fontSize: '0.75rem',
            fontWeight: '400',
            letterSpacing: '0.4px',
            lineHeight: '166%'
        },
        overline: {
            fontSize: '0.75rem',
            fontWeight: '400',
            letterSpacing: '0.35px',
            lineHeight: '150%'
        },
        accordion: {
            fontSize: '1rem',
            fontWeight: '550',
            lineHeight: '130%',
            letterSpacing: '0.15px',
        },
        linkLabel: {
            fontSize: '1rem',
            fontWeight: '700',
            fontFamily: 'var(--font-family-bold)',
            letterSpacing: '0.15px',
            lineHeight: '150%'
        },
        blockQuote: {
            textAlign: 'center',
            fontSize: '40px',
            fontStyle: 'normal',
            fontWeight: 450,
            lineHeight: '140%',
        }
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiButton: {
            defaultProps: {
                style: {
                    borderRadius: 999
                }
            }
        },
        MuiCard: {
            defaultProps: {
                style: {
                    borderRadius: 0
                }
            }
        },
        MuiAccordion: {
            styleOverrides: {
                root: ({theme}) => ({
                    "&:before": {
                        display: 'none',
                        backgroundColor: "transparent !important",
                    },
                    '& .Mui-expanded .MuiAccordionSummary-content p, .Mui-expanded .MuiAccordionSummary-expandIconWrapper': {
                        color: theme.palette.primary.main
                    },

                }),
            },
            defaultProps: {
                style: {
                    borderBottom: "0px solid #333333",
                    borderTop: "1px solid #e0e0e0",
                    borderRadius: "0",
                    boxShadow: "none",
                }
            }
        },
    },
};

// Adding custom typography variant
declare module '@mui/material/styles' {
    interface TypographyVariants {
        accordion: React.CSSProperties;
    }

    interface TypographyVariantsOptions {
        accordion?: React.CSSProperties;
    }
}
declare module '@mui/material/Typography' {
    interface TypographyPropsVariantOverrides {
        accordion: true;
    }
}


export default testamentTheme;